module.exports = __webpack_public_path__ + "img/inscription.5fea7f35.png";